export class CUTimeSlots {
    timeslotid: number;
    timeslotstart: string;
    timeslotend: string;
    description: string;

    constructor() {
        this.timeslotid = undefined;
        this.timeslotstart = '';
        this.timeslotend = '';
        this.description = '';
    }
}

export class CuSubscriptionSlots {
    subscriptionkey: string;
    ranking: number;
    rankingnote: string;
    timeslotnote: string;
    dbsize: SubscriptionSize;

    constructor() {
        this.subscriptionkey = '';
        this.dbsize = 0;
        this.ranking = undefined;
        this.rankingnote = '';
        this.timeslotnote = '';
    }
}

export enum SubscriptionSize {
    None,
    Standard /* 0 - 100MB */,
    Large /* 100MB - 1000MB */,
    ExtraLarge /* 1000MB - 10000MB */,
    Ultra /* 10000MB - to infinity*/,
}
